import {
  activeSessionsQueryKey,
  useActiveSessions as useActiveSessionsCore,
} from "@be-miniapp/shared/queries/use-active-sessions"
import { useModal } from "@be-miniapp/ui/hooks/use-modal"

import { useLogout } from "@/hooks/use-logout"
import { useUserStore } from "@/store/user-session"

export { activeSessionsQueryKey }

interface ActiveSessionsQueryData {
  data: {
    engagementId: string
    currentState: string
  }
}

export function useActiveSessions({
  data: { engagementId, currentState },
}: ActiveSessionsQueryData) {
  const logout = useLogout()
  const accessToken = useUserStore((state) => state.access_token)
  const modal = useModal()

  return useActiveSessionsCore({
    data: { engagementId, currentState },
    accessToken,
    logout: () => logout(),
    modal,
    refetchInterval: 5000,
  })
}
